import { buildCssClassName } from "@/3514/utils"

import "../styles.scss"

type Props = {
    variant: "active" | "system" | "other"
    message: string
    onClickMessage: () => void
}

export const SimulabChatMessage = ({ variant, message, onClickMessage }: Props) => {
    return (
        <div
            className={buildCssClassName("simulab-chat-message", variant)}
            onClick={onClickMessage}
            data-testid="simulab-chat-message"
        >
            <span>{message}</span>
        </div>
    )
}
